module.exports = __webpack_public_path__ + "img/Octocat-momtocat.8b9bfef4.png";